import React, { Fragment } from 'react';

import { SkeletonText, Text, TooltipWrapper } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { useQueryPlatformVersions } from 'app/developer-v3/hooks';

type Props = {
  isCLI: boolean;
  platformVersion: string;
  version: string;
};

function PlatformVersionMessage({ isCLI, platformVersion, version }: Props) {
  const { data: platformVersions, isLoading } = useQueryPlatformVersions({
    staleTime: 600000,
  });
  const latestPlatformVersion = platformVersions?.[0]?.version;

  return isLoading ? (
    <SkeletonText lines={1} />
  ) : (
    <Text margin="0 0 20px" tag="p">
      Version <strong>{version}</strong> is running on Platform{' '}
      <strong>
        {isCLI ? (
          platformVersion
        ) : (
          <TooltipWrapper
            content={
              <Fragment>
                The latest is <strong>{latestPlatformVersion}</strong>.
              </Fragment>
            }
          >
            {() => platformVersion}
          </TooltipWrapper>
        )}
      </strong>
      .
      {isCLI && platformVersion !== latestPlatformVersion && (
        <Fragment>
          {' '}
          The latest is <strong>{latestPlatformVersion}</strong>.
        </Fragment>
      )}{' '}
      See the{' '}
      <Link
        href="https://github.com/zapier/zapier-platform/blob/main/CHANGELOG.md"
        target="_blank"
      >
        changelogs
      </Link>{' '}
      for what’s new.
    </Text>
  );
}

export default PlatformVersionMessage;
